/* globals jQuery */
import { easing } from './_vars.js';

(function(window, document, $) {

    function closeMenu(menuButton, menuToClose) {
        menuToClose.slideToggle(250, easing, function () {
            $(menuButton).removeClass('responsive-toggle-open');
            menuToClose.removeAttr('style');
        });
    }

    function openMenu(menuButton, menuToOpen) {
        menuToOpen.slideToggle(250, easing, function () {
            $(menuButton).addClass('responsive-toggle-open');
            if (menuToOpen.is('#menu-account')) {
                menuToOpen.css({ display: 'block' });
            } else {
                menuToOpen.css({ display: 'inherit' });
            }
        });
    }

    function menuShouldClose(element) {
        const menuToToggle = $(`#${$(element).data('open')}`);
        const isMainMenuVisible = menuToToggle.find('.dropdown-only').is(':visible');
        const isAccountMenuVisible = menuToToggle.is('#menu-account:visible');
        return {
            shouldClose: isMainMenuVisible || isAccountMenuVisible, 
            menuToToggle
        };
    }

    $(document).ready(function() {
        $('#responsive-menu-button, #account-menu-button').on('click', function(event) {
            // Don't trigger html click on button click
            event.stopPropagation();
            const { shouldClose, menuToToggle } = menuShouldClose(this);
            if (shouldClose) {
                closeMenu(this, menuToToggle);
            } else {
                openMenu(this, menuToToggle);
            }
        });

        // Close any visible dropdown menu when html is clicked
        $(document).on('click', 'html', function() {
            $('#responsive-menu-button, #account-menu-button').each(function(index, element) {
                const { shouldClose, menuToToggle } = menuShouldClose(this);
                if (shouldClose) {
                    closeMenu(element, menuToToggle);
                }
            });
        });

        // Stop propagation on click on menu.
        $('#menu-main').click(function (event) {
            var pathname = window.location.pathname;
            if (pathname !== '/wp-admin/customize.php') {
                event.stopPropagation();
            }
        });
    });

}(window, document, jQuery));
